/* eslint-disable react/prop-types */
import React from "react";
import { Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  formTitle: {
    marginBottom: "15px",
  },
}));

const FormTitle = ({ children }) => {
  const classes = useStyles();
  return (
    <>
      <Typography
        align="center"
        component="h1"
        variant="h6"
        classes={{ h6: classes.formTitle }}
        data-testid="form-title"
      >
        {children}
      </Typography>
    </>
  );
};

export default FormTitle;
